import React, { CSSProperties } from 'react';
import { useReduxState } from 'hooks';
import { Badge, ProgressBar, Tooltip } from 'components/common';
import { PathCompletionStatus, PathProgressTooltip } from '.';

import type {
  PathStep,
  PathStepProgress,
  ResolvedItemInPathStep
} from 'shared-types';

interface Props {
  id: number | string;
  notStartedLabel?: string;
  progressData: PathStepProgress;
  showNotStarted?: boolean;
  steps: (Omit<PathStep, 'createdAt' | 'updatedAt'> & {
    items: ResolvedItemInPathStep[];
  })[];
  style?: CSSProperties;
}

const PathProgressStatus = ({
  id,
  notStartedLabel,
  progressData,
  showNotStarted = true,
  steps,
  style = {}
}: Props) => {
  const { messages, theme } = useReduxState();

  const { numberOfSteps, stepsStarted, stepsCompleted, pathCompletion } =
    progressData;

  const totalProgress = numberOfSteps ? stepsCompleted / numberOfSteps : 0;

  return (
    <div className="status" style={{ ...style }}>
      {pathCompletion || stepsStarted ? (
        <Tooltip
          content={
            <PathProgressTooltip progressData={progressData} steps={steps} />
          }
          contentStyle={{ padding: 0 }}
          isLight={true}
        >
          {pathCompletion ? (
            <PathCompletionStatus
              pathCompletion={pathCompletion}
              showDate={false}
              showTooltip={false}
            />
          ) : stepsStarted ? (
            <Badge
              isRounded={false}
              text={
                <div style={{ display: 'inline-flex', flexDirection: 'row' }}>
                  <div>{`${stepsCompleted} / ${numberOfSteps}`}</div>
                  <ProgressBar
                    color="#555"
                    progress={totalProgress || 0}
                    style={{ margin: '5px 0 5px 8px', width: 60 }}
                  />
                </div>
              }
            />
          ) : null}
        </Tooltip>
      ) : showNotStarted ? (
        <Badge
          isRounded={false}
          text={notStartedLabel || messages.commonNotStarted}
        />
      ) : null}

      <style jsx>{`
        .item {
          display: flex;
          padding: 6px 3px;
        }
        .label {
          flex-grow: 1;
          margin-right: 20px;
        }
        .value {
          display: inline-flex;
        }
        .empty {
          color: ${theme.textColorLighter};
        }
      `}</style>
    </div>
  );
};

export default PathProgressStatus;
